import React from "react";
import {
  HEROSECTION,
  DOCTORTEAM,
  STARICON,
  CALENDERHEART,
  FILTESIMG,
  MOBILEEXPLOUR,
  SHIELDCHECK,
  VIDEOCALLMEN,
  VIDEOCONFERENCE,
  ARROW_ICON,
  BLUEARROW_ICON,
  MISSION_IMG,
  MISSION_ICON,
  VISSION_ICON,
  VISION_IMG,
  EYEVISION_IMG,
  ADVANTAL_IMG,
  PRIMIUMVISION_IMG,
  PHONE1,
  PHONE2,
  EYE_ICON,
  DENTAL_ICON,
  FOOD_ICON,
  DIGONIST_ICON,
  MEDICAL_ICON,
  SAFTY_ICON,
  QUALITY_ICON,
  PRODUCTS_IMG,
  ABOUTIMG,
  ABOUTARROW_ICON,
  GOOGLE_IMG,
  APPLE_IMG,
  CROUSEL_IMG1,
  crousel_IMG2,
  ABOUTARIMG,
  ABOUTFRIMG,
  VISION_IMGAR,
  VISION_IMGFR,
  PRODUCTS_IMGFR,
  PRODUCTS_IMGAR,
} from "../../utils/aap-image-constant";
import DoctorsSlider from "./doctorslider";
import { Link } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import Button from "../../components/common/button";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptAEStoJSON, encryptStringtoAES } from "../../utils/utilities";
import Contactus from "./contact";

const Home = () => {
  const { t, i18n } = useTranslation();
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  localStorage.setItem("languageChange", encryptStringtoAES(i18n.language));
  return (
    <>
      <div className="">
        <div className="Home_Sections">
          {/*herosection */}
          <div className="container HeroSections_Content">
            <div className="row">
              {/* Left Column */}
              <div className="col-12 col-lg-7">
                <div className=" mt-lg-4 mt-0 d-flex align-items-center rounded-5 flex-column flex-sm-row justify-content-center justify-content-sm-start">
                  <div className="bagescolor rounded-5 py-2 px-3 mb-3">
                    <img src={STARICON} alt="Star Icon" className=" " />
                    <span className="textcolor mx-2 grayparaColor fw-500">
                      {t(
                        "Rated #1 choice for healthcare appointments by users"
                      )}
                    </span>
                  </div>
                </div>

                <h1 className="title">
                  {t("The New Era of ")}
                  <span className="italic-text  textcolor">{t("Healthcare")}</span>{" "}
                </h1>
                <p className=" mt-3 grayparaColor">
                  {t(
                    "We're here to link you directly to improved health outcomes, effortlessly connecting you with the care you need."
                  )}
                </p>
                <Link to={userData?.email ? ROUTES.DASHBOARD : ROUTES.REGISTER}>
                  <Button
                    className="rounded10 border-0 py-2 px-3 fs-14 fw-600 bg-blue text-white mt-4 mb-lg-0 mb-3 cursor-pointer "
                    label={userData && userData?.email ? "Dashboard" : "Register"}
                    type="button"
                    icon={ARROW_ICON}
                  />
                </Link>
              </div>

              {/* Right Column */}
              {/* <div className="col-12 col-lg-5 ">
                <img
                  src={HEROSECTION}
                  alt="Star Icon"
                  className=" img-fluid "
                />
              </div> */}

              {/* Right Column */}
              <div className="col-12 col-lg-5">
                <div
                  id="heroCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >

                  <div className="carousel-inner rounded-4">

                    <div className="carousel-item active">
                      <img
                        src={HEROSECTION}
                        className="hero-carousel-img"
                        alt="Healthcare Slide 1"
                      />
                    </div>

                    <div className="carousel-item">
                      <img
                        src={CROUSEL_IMG1}
                        className="hero-carousel-img"
                        alt="Healthcare Slide 2"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={crousel_IMG2}
                        className="hero-carousel-img"
                        alt="Healthcare Slide 2"
                      />
                    </div>

                  </div>
                  <div className="carousel-indicators custom-indicators">
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1"></button>
                    <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2"></button>

                  </div>

                  {/* Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#heroCarousel"
                    data-bs-slide="prev"
                  >
                    <span className="carousel-control-prev-icon"></span>
                  </button>

                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#heroCarousel"
                    data-bs-slide="next"
                  >
                    <span className="carousel-control-next-icon"></span>
                  </button>

                </div>
              </div>
            </div>
          </div>


          <div className="my-4 py-4 bgcard">
            <div className="container">
              <div className="row ">

                {/* Card 1 */}
                <div className="col-md-4">
                  <div className="feature-card h-100 d-flex align-items-center">
                    <div className="icon-box">
                      <img src={DENTAL_ICON} alt="Expert Doctors" />
                    </div>
                    <div className="mx-3">
                      <p className="mb-1 fw-semibold">{t("Expert Doctors")}</p>
                      <p className="mb-0 small ">
                        {t("Skilled professionals delivering top-quality care.")}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Card 2 (Active) */}
                <div className="col-md-4">
                  <div className="feature-card  h-100 d-flex align-items-center">
                    <div className="icon-box">
                      <img src={QUALITY_ICON} alt="High Quality" />
                    </div>
                    <div className="mx-3">
                      <p className="mb-1 fw-600">{t("High-quality")}</p>
                      <p className="mb-0 small">
                        {t("Fast, reliable treatment when you need it most.")}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="col-md-4">
                  <div className="feature-card h-100  d-flex align-items-center">
                    <div className="icon-box">
                      <img src={SAFTY_ICON} alt="Safety" />
                    </div>
                    <div className="mx-3">
                      <p className="mb-1 fw-600">{t("Safety")}</p>
                      <p className="mb-0 small ">
                        {t("Always here for appointments and emergencies.")}
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>

          {/* abouts us */}

          <div class="about-section  my-5">
            <div class="row">

              <div class="col-12 col-md-5">
                <img
                  src={
                    i18n.language === "en"
                      ? ABOUTIMG
                      : i18n.language === "fr"
                        ? ABOUTFRIMG
                        : ABOUTARIMG
                  }
                  class="mini-doc mb-3 mb-lg-0"
                  alt=""
                />
              </div>

              <div class="col-12 col-md-7 p-4 p-md-3 pe-lg-5">
                <span className="textcolor bagescolor fw-600  rounded-5 py-2 px-3 mb-3 grayparaColor fw-500">
                  <img src={STARICON} alt="Star Icon" className="me-2" />
                  {t(
                    "About Us"
                  )}
                </span>
                <h4 class="fw-bold my-3 formate-text " >
                  {t(
                    "We welcome a world of limitless possibilities, where every journey is as meaningful as its destination, and every moment is an opportunity to shape the future of healthcare.The only limit is the reach of imagination."
                  )}
                </h4>

                <p class="text-muted formate-text ">
                  {t("INNOVIER is built on the belief that the pursuit of knowledge, the courage to embrace change, and the willingness to take calculated risks are not optional — they are essential. This mindset defines who we are and how we innovate.")}                </p>
                <div className="my-2">
                  <img src={ABOUTARROW_ICON} alt="Star Icon" className="mx-2" /><span className="fw-500">{t("Make a schedule online is easy")}</span>
                </div>
                <div>
                  <img src={ABOUTARROW_ICON} alt="Star Icon" className="mx-2" /><span className="fw-500">{t("Easy to connect with doctor")}</span>
                </div>
                <Link to={userData?.email ? ROUTES.DOCTOR : ROUTES.REGISTER}>
                  <button class="btn btn-primary px-4 py-2 mt-4 rounded-3">
                    {t("See Doctors")}
                  </button>
                </Link>

              </div>
            </div>
          </div>
          <div className="container Doctorslide_Content">
            <DoctorsSlider />
          </div>
          {/* "professinal sections" */}
          {/* <div className="Professionalsection_content my-md-4 my-2">
            <div className="row text-center text-lg-start">
         
              <div className="col-12 col-lg-5 mb-3 mb-lg-0">
                <div className="card border-0 h-100">
                  <img
                    src={DOCTORTEAM}
                    alt="Doctors"
                    className="img-fluid rounded-4"
                  />
                </div>
              </div>

            
              <div className="col-12 col-lg-7 card border-0 h-100 mb-3 mb-lg-0">
          
                <div className=" d-flex align-items-center gap-2  flex-column flex-sm-row justify-content-center justify-content-lg-start">
                  <div className="bagescolor px-4 rounded-5 py-2">
                    <img src={STARICON} alt="Star Icon" />{" "}
                    <span className="textcolor fw-500  mx-2">
                      {t(
                        "choice for healthcare appointments by users"
                      )}
                    </span>
                  </div>
                </div>

                <h4 className=" h4-heading fw-semibold mt-4">
                  {t(
                    "We're revolutionizing healthcare with seamless access to trusted professionals, prioritizing your journey to better health."
                  )}
                </h4>

                <div className="row mt-3">
                  <div className="col-12 col-lg-6">
                    <div className="">
                      <h1 className="textcolor mb-2">40+</h1>
                      <p className="text-muted grayparaColor fs-14 mb-2">{t("Dedicated Doctors")}</p>
                    </div>

                  </div>
                  <div className="col-12 col-lg-6">
                    <h1 className="textcolor mb-2">10K+</h1>
                    <p className="text-muted grayparaColor fs-14 mb-2">
                      {t("Hours of Patient Consultations")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* banner sections */}
          <div className="container home-banner rounded10 d-flex align-items-center my-4">
            <div className={`banner_content ${i18n.language === "ar" ? "banner_contentarabic" : ""
              }`}>
              <h2 className="fw-500 mb-2 text-white">
                {t("Register As Doctor: Transform Lives, Start with Yours.")}
              </h2>

              <Link to={userData?.email ? ROUTES.DASHBOARD : ROUTES.REGISTER}>
                <Button
                  className="rounded10 border-0 textcolor fs-16 fw-600 bg-sky-blue mt-2 registrbtn"
                  label={userData && userData?.email ? "Dashboard" : "Register"}
                  type="button"
                  icon={BLUEARROW_ICON}
                />
              </Link>
            </div>
          </div>
          {/* //mission sections */}

          <div className="container Professionalsection_content  my-4">
            <h2 className="mainheading fs-45 fw-600  text-start my-4">
              {t(`Our`)}
              <span className="textcolor italic-text "> {t("Values")}</span>
            </h2>
            <div className="row text-center text-lg-start">



              <div className="col-12 col-lg-5 card border-0 h-100 mb-3 mb-lg-0">

                <div className=" d-flex align-items-center gap-2  flex-column flex-sm-row justify-content-center justify-content-lg-start">
                  <img src={MISSION_ICON} alt="Star Icon" />{" "}
                  <span className="fw-semibold fs-3  mx-2">
                    {t("Our Mission")}
                  </span>
                </div>

                {/* Heading */}
                <p className=" mt-4 formate-text " >
                  {t(
                    "Our mission is to deliver a global, forward-thinking approach to healthcare by developing, marketing, and expanding access to"
                  )} <span className="textcolor  mt-3">
                    {t(
                      "highly innovative medical and healthcare products worldwide."
                    )}
                  </span>
                </p>


              </div>
              <div className="col-12 col-lg-7 mb-3 mb-lg-0">
                <div className="card border-0 h-100">
                  <img
                    src={MISSION_IMG}
                    alt="Doctors"
                    className="img-fluid rounded-4"
                  />
                </div>
              </div>
            </div>
            <div className="row g-2 my-4">
              <div className="col-md-6">
                <div className="card h-100  rounded-4">
                  <div className="card-body">
                    <div className="py-2">
                      <img
                        src={FILTESIMG}
                        className="img-fluid icon-circle p-1 rounded-5 explour_icon"
                        alt="img"
                      />
                    </div>
                    <h5 className="card-title h4-heading fw-semibold">
                      {t("Supporting Practitioners")}
                    </h5>
                    <p className="card-text grayparaColor formate-text " >
                      {t(
                        "Empowering health practitioners at every stage. From smart agendas and virtual consultations to career growth, job matching, and premium medical supplies. we support your journey and your patients."
                      )}
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Small Card */}
              <div className="col-md-6">
                <div className="card h-100  rounded-4 ">
                  <div className="card-body">
                    <div className="py-2">
                      <img
                        src={VIDEOCONFERENCE}
                        className="img-fluid icon-circle p-1 rounded-5 explour_icon"
                        alt="img"
                      />
                    </div>
                    <h5 className="card-title h4-heading fw-semibold">
                      {t("Scientific Transfer")}
                    </h5>
                    <p className="card-text grayparaColor formate-text " >
                      {t(
                        "We are committed to the transfer of scientific knowledge across generations, taking responsibility for education by offering high-quality, internationally accredited courses in medical and surgical fields."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row text-center text-lg-start my-4">
              {/* Text Column */}
              <div className="col-12 col-lg-6 card border-0 h-100 mb-3 mb-lg-0">
                {/* Badge Section */}
                <div className=" d-flex align-items-center gap-2  flex-column flex-sm-row justify-content-center justify-content-lg-start">
                  <img src={VISSION_ICON} alt="Star Icon" />{" "}
                  <span className="fw-semibold fs-3  mx-2">
                    {t(
                      "Our Vision"
                    )}
                  </span>
                </div>

                {/* Heading */}
                <p className=" mt-4 formate-text " >
                  {t(
                    "Welcome to a world of limitless possibilities, where the journey is as exhilarating as the destination,and where every moment is an opportunity to make your mark on the canvas of existence.The only limit is the extent of your imagination."
                  )}
                </p>
                <p className="textcolor fs-5 p-2 my-3 formate-text  " style={{ backgroundColor: "#FBFEFF", borderLeft: "3px solid #0099FF" }}>
                  {t("Innovative advanced high quality medical technologies is")} <strong className="textcolor">{t("INNOVIER")}</strong> {t("responsibility")}.
                </p>
                <p className="formate-text ">
                  {t("Wide range of Products envisioned by internal Medical Doctors whose aim is to participate in the career development and the advancement of science.")}                </p>


              </div>
              <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                <div className="card border-0 h-100">

                  <img
                    src={
                      i18n.language === "en"
                        ? VISION_IMG
                        : i18n.language === "fr"
                          ? VISION_IMGFR
                          : VISION_IMGAR
                    }
                    className="img-fluid rounded-4"
                    alt="doctor"
                  />
                </div>
              </div>
            </div>

            {/* success partner */}
            <div className="row text-center text-lg-start my-4">


              {/* Text Column */}
              <div className="col-12 col-lg-5 card border-0 h-100 mb-3 mb-lg-0">
                {/* Badge Section */}
                <h2 className="mainheading fs-45 fw-600  text-start " >
                  {t(`success`)}
                  <span className="textcolor italic-text "> {t("partners")}</span>
                </h2>
                {/* Heading */}
                <p className=" mt-4 formate-text " >
                  {t(
                    "Stronger together. Our partners are the cornerstone of our mission, providing the expertise and technology that fuel the future of medical care at INNOVIER."
                  )}
                </p>


              </div>
              <div className="col-12 col-lg-7 mb-3 mb-lg-0">
                <div className="row">
                  <div className="col p-0 " style={{ marginTop: "-20px" }}>
                    <img
                      src={EYEVISION_IMG}
                      alt="Doctors"
                      className="img-fluid rounded-4"
                    />
                  </div>
                  <div className="col p-0">
                    <img
                      src={PRIMIUMVISION_IMG}
                      alt="Doctors"
                      className="img-fluid rounded-4"
                    />
                  </div>
                  <div className="col p-0" style={{ marginTop: "20px" }}>
                    <img
                      src={ADVANTAL_IMG}
                      alt="Doctors"
                      className="img-fluid rounded-4"
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
          {/* our products */}
          <div className="container my-5">
            <h2 className="mainheading fs-45 fw-600  text-start my-4">
              {t(`Our`)}
              <span className="textcolor italic-text "> {t("products")}</span>
            </h2>
            <section class="products-section bg-card my-3 ">
              <div class="row align-items-center ">

                <div class="col-lg-6">
                  <div className="px-4 py-2">
                    <h5 class="fw-bold mb-3">{t("Digital Health")}</h5>

                    <p class="text-muted formate-text ">
                      {t("MEDIER Health Application: A comprehensive platform simplifying agendas, virtual clinics, and healthcare job matching.")}
                    </p>

                    <div class="row mt-3">
                      <small class="fw-bold d-block mb-2">{t("KEY FEATURES")}</small>
                      <div class="col-6">
                        <ul class="feature-list">
                          <li>{t("Virtual Clinics")}</li>
                          <li>{t("Job Matching")}</li>
                        </ul>
                      </div>

                      <div class="col-6">
                        <ul class=" feature-list">
                          <li>{t("Agenda Management")}</li>
                          <li>{t("Patient Records")}</li>
                        </ul>

                      </div>
                    </div>
                    <div class=" d-flex mt-3">
                      <img src={GOOGLE_IMG} class="img-fluid mx-2" alt="App UI" />
                      <img src={APPLE_IMG} class="img-fluid " alt="App UI" />
                    </div>
                  </div>

                </div>

                <div class="col-lg-6 ">
                  <div class="phones-wrapper d-flex ">
                    <img
                      src={
                        i18n.language === "en"
                          ? PRODUCTS_IMG
                          : i18n.language === "fr"
                            ? PRODUCTS_IMGFR
                            : PRODUCTS_IMGAR
                      }
                      className="img-fluid phone phone-main"
                      style={{ marginTop: "-128px" }}
                      alt="our products"
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
          {/* "exp,lore app" */}
          {/* <div className="ExplourFeatures_content mb-3 ">
            <h2 className="mainheading fs-45 fw-600 text-md-center text-lg-start my-4">
              {t(`Explore Our App's`)}
              <span className="textcolor italic-text "> {t("Features")}</span>
            </h2>
            <div className="row g-2">
              <div className="col-md-8 ">
                <div className="card mb-2  bg-card border-0 rounded-4">
                  <div className="container">
                    <div className="row g-0">
                      <div className="col-md-7 d-flex flex-column justify-content-center">
                        <div className="py-3">
                          <img
                            src={CALENDERHEART}
                            className="img-fluid icon-circle p-1 rounded-5 explour_icon "
                            alt="img"
                          />
                        </div>
                        <h3 className="card-title h4-heading fw-semibold">
                          {t("Convenient Online Booking")}
                        </h3>
                        <p className="card-text grayparaColor">
                          {t(
                            `Easily schedule consultations and meetings with healthcare professionals through our user-friendly online booking platform.`
                          )}
                        </p>
                      </div>
                      <div className="col-md-5 text-center mt-lg-4 mt-2 ">
                        <img
                          src={MOBILEEXPLOUR}
                          className=" img-fluid Mobileimg"
                          alt="Mobile Booking"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row g-2">
                  <div className="col-md-6">
                    <div className="card h-100 bg-card border-0 rounded-4">
                      <div className="card-body">
                        <div className="py-2">
                          <img
                            src={FILTESIMG}
                            className="img-fluid icon-circle p-1 rounded-5 explour_icon"
                            alt="img"
                          />
                        </div>
                        <h4 className="card-title h4-heading fw-semibold">
                          {t("Records Management")}
                        </h4>
                        <p className="card-text grayparaColor">
                          {t(
                            "Effortlessly store and access patient medical records, ensuring vital information is available for healthcare providers during appointments."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card h-100 bg-card border-0 rounded-4 ">
                      <div className="card-body">
                        <div className="py-2">
                          <img
                            src={VIDEOCONFERENCE}
                            className="img-fluid icon-circle p-1 rounded-5 explour_icon"
                            alt="img"
                          />
                        </div>
                        <h4 className="card-title h4-heading fw-semibold">
                          {t("Instant Confirmation")}
                        </h4>
                        <p className="card-text grayparaColor">
                          {t(
                            "Receive instant confirmation of your booked appointments, along with timely reminders to ensure you never miss a meeting."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 bg-card border-0 rounded-4">
                  <div className="card-body ">
                    <div className="py-2">
                      <img
                        src={SHIELDCHECK}
                        className="img-fluid icon-circle p-1 rounded-5 explour_icon"
                        alt="img"
                      />
                    </div>
                    <h4 className="card-title h4-heading fw-semibold">
                      {t("Secure Virtual Meetings")}
                    </h4>
                    <p className="card-text grayparaColor">
                      {t(
                        "Experience secure and convenient virtual consultations from home. Our encrypted video conferencing guarantees confidential interactions, removing the need for in-person visits."
                      )}
                    </p>
                  </div>
                  <div className="text-center">
                    <img
                      src={VIDEOCALLMEN}
                      className="img-fluid videoimg"
                      alt="Video Call"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* services  */}

          <div className="container my-5">
            <div className="row g-4">

              {/* ===== FIRST ROW (3 CARDS) ===== */}
              <div className="col-md-4">
                <div className="card h-100 service-card  p-5 rounded-4 border-0">
                  <img
                    src={EYE_ICON}
                    className="img-fluid service-icon"
                    alt="img"
                  />
                  <p className="mb-2 fw-600">{t("Eye Care Line")}</p>
                  <p className="small" >
                    {t("A global range of ophthalmology solutions for comprehensive eye care.")}
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card h-100 service-card  p-5 rounded-4 border-0">
                  <img
                    src={DENTAL_ICON}
                    className="img-fluid service-icon  "
                    alt="img"
                  />
                  <p className="fw-600  mb-2">{t("Dental Care")}</p>
                  <p className="small ">
                    {t("Advanced dental care solutions for practitioners and patients.")}
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card h-100 service-card p-5 rounded-4 border-0">
                  <img
                    src={FOOD_ICON}
                    className="img-fluid service-icon"
                    alt="img"
                  />
                  <p className="mb-2 fw-600">{t("Food Supplements")}</p>
                  <p className=" small">
                    {t("High-quality oral complementary vitamins and formulations.")}
                  </p>
                </div>
              </div>

              {/* ===== SECOND ROW (2 CENTERED CARDS) ===== */}

              <div className="col-md-4 offset-md-2">
                <div className="card h-100 service-card  p-5 rounded-4 border-0">
                  <img
                    src={DIGONIST_ICON}
                    className="img-fluid service-icon"
                    alt="img"
                  />
                  <p className="fw-600 mb-2">{t("Diagnostic Products")}</p>
                  <p className=" small">
                    {t("Advanced diagnostic solutions for accurate medical assessment.")}
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card h-100 service-card  p-5 rounded-4 border-0">
                  <img
                    src={MEDICAL_ICON}
                    className="img-fluid service-icon"
                    alt="img"
                  />
                  <p className="fw-600 mb-2">{t("Medical Devices")}</p>
                  <p className=" small">
                    {t("Innovative, high-quality medical equipment for hospitals and clinics.")}
                  </p>
                </div>
              </div>

            </div>
          </div>
          {/* Contact Us */}
          <div className="container Contactus_content ">
            <Contactus />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
